import { render, staticRenderFns } from "./TransactionRowDetail.vue?vue&type=template&id=4dff4d64&scoped=true&"
import script from "./TransactionRowDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionRowDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRowDetail.vue?vue&type=style&index=0&id=4dff4d64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff4d64",
  null
  
)

export default component.exports